import script from "./YB.vue?vue&type=script&setup=true&lang=js"
export * from "./YB.vue?vue&type=script&setup=true&lang=js"

import "./YB.vue?vue&type=style&index=0&id=1f730895&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f730895"]])

export default __exports__